import { IconChevronRight as TablerIconChevronRight } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconChevronRight = /*#__PURE__*/ createOutlineIcon(
  TablerIconChevronRight,
  'IconChevronRight',
);
